import React from "react";

const Delievery = () => {
  return (
    <div>
      <h2>DELIVERY TIME</h2>
      <ul>
        <li>
          The estimated average Delivery time (after the order is
          dispatched ) across Pakistan is 2 to 4 working days for the
          major cities. For remote areas delivery can take longer.
        </li>
        <li>
          You are requested to be available on the provided contact
          number so our team can reach you.
        </li>
        <li>
          Timely delivery is subjected to availability of the articles
          and order confirmation.
        </li>
        <li>
          During sale period, both order processing and delivery may
          take longer than usual.
        </li>
      </ul>
      <h2>INTERNATIONAL DELIVERY</h2>
      <ul>
        <li>
          The estimated dispatch time for International order is 5 to
          7 working after the order has been confirmed.
        </li>
        <li>
          The delivery time may vary depending on the destination.
        </li>
        <li>
          J. will not be responsible for any refund if the consignee
          requests for order cancelation once the order "is in
          process".
        </li>
        <li>
          Customers will be liable to bear the shipment and custom
          charges if they refuse or receive the delivery.
        </li>

        <li>
          During Sale events, average delivery time can exceed than
          normal
        </li>
      </ul>
      <h2>CANCELLATION POLICY</h2>
      <ul>
        <li>
          For cancellation of prepaid orders, please contact us within
          24 hours after order placement.
        </li>
        <li>
          Once the Order is “in process”, it can no longer be canceled
          or refunded.
        </li>
      </ul>
      <h2>PAYMENT THROUGH CARDS:</h2>
      <ul>
        <li>
          We aim to provide a safe and secure shopping experience.
          However, In some instances, we might need some form of
          payment verification or source to process the order, which
          will be requested from the consignee through call or email
          as per the bank's instructions to avoid any fraudulent or
          suspicious transactions. ( For Further Instruction Please
          Click )
        </li>
        <li>
          J. reserves the right to cancel orders if the payment is
          declined by your authorized payment institution.
        </li>
      </ul>
      <h2>DELIVERY CHARGES</h2>
      <ul>
        <li>
          We offer Free Delivery for all the orders above Rs. 1500/-
          within Pakistan.
        </li>
        <li>
          For orders below Rs. 1500, standard delivery rates will be
          charged based on the Payment method:
        </li>
      </ul>
      <h2>
        Cash on delivery: Rupees 200/-. Online/Bank Transfer/Prepay:
        Rupees 100/-.
      </h2>
      <ul>
        <li>
          Charges for all International delivery vary from country to
          country depending upon city, state, country, and locality.
          To calculate shipment charges you can select any product and
          checkout with your delivery address to calculate the
          estimated delivery charges (doesn’t include any taxes &
          duties).
        </li>
        <li>
          Please note that international orders may be subject to
          taxes & duties and will be the responsibility of the
          customer. Any applicable duties or fees will be collected at
          the time of order delivery by the courier.
        </li>
      </ul>
      <h2>TRACK YOUR ORDER</h2>
      <ul>
        <li>
          Once your order is dispatched you will receive an email/SMS
          with your tracking number.
        </li>
        <li>
          You can track your order on the respective courier website
          mentioned in your email.
        </li>
        <li>
          If you don't get any tracking updates, please write to us at
          eshop@junaidjamshed.com
        </li>
        <li>
          If you don't get any tracking updates, please write to us at
          eshop@junaidjamshed.com
        </li>
      </ul>
      <h2>WANT TO AMEND YOUR ORDER?</h2>
      <p>
        ou can revise your order so that it's just the way you want it
        by calling our Customer Services team on 021 111 112 111 (9 am
        - 10 pm, PKT Mon-Sat, 11 am – 8 pm on Sundays) or emailing us
        at eshop@junaidjamshed.com before order is processed. If the
        order hasn’t already been processed, we'll be happy to assist
        you.
      </p>
    </div>
  );
};

export default Delievery;
